<template> 
  <div id="mobile-mega-menu" :class="isDepartment">
    <button @click="toggleMenu(1)" class="navbar-text navbar-right" id="mobileMegaMenuToggle" title="Menu" tabindex="0">
      <i class="far fa-bars" title="Main Navigation Menu" aria-label="Main Navigation Menu"></i> 
      <span class="sr-hidden">Menu</span>
    </button>

      <div class="panel level-1" :class="{ active : open === 1 }">
          <CloseMenu 
            @click.native="toggleMenu(0)" 
            :name="'Global site'" 
          />
          <MenuButton 
            :id="'mmmPayOrApply'"
            :name="'Pay or Apply'"
            :icon="'fas fa-file-check'"
            :url="'/pay-and-apply'"
            :excerpt="'Bills, tickets, permits, reservations'"
          />
          <MenuButton 
            v-for="(menu, i) in menus" 
            :key="menu.name"
            :isActive="open === i" 
            :id="'mmmButton' + (i+1)"
            :name="menu.name"
            :icon="menu.promo.icon"
            :excerpt="menu.excerpt"
            @click.native="toggleMenu(i+2, i+1)"
          />
      </div>

        <div class="panel level-2"
          v-for="(menu, i) in menus" 
          :key="'panel' + i"
          :id="'mmmPanel_' + (i + 1)"
          :class="{ active : open === i + 2 }"
        >
          <CloseMenu
            :id="'mmmPanelClose' + (i + 1)"
            @click.native="toggleMenu(0)"
            :name="menus[i].name"
          />
          <button class="back-button" @click="toggleMenu(1, subMenuIndex + 1)">
            <i class="far fa-chevron-left" aria-hidden></i>
            <span class="sr-only">Back to</span> 
            <span class="name">{{ menus[i].name }}</span>
          </button>
          <Accordions :lists="menus[i].lists" :addHeaderToLinks="true" :idPrefix="'mmmPanel_' + (i + 1) + '_'"/>
        </div>

    <transition name="fade">
      <MenuOverlay v-if="open != 0" @click.native="toggleMenu(0)" />
    </transition>
  </div>
</template>

<script>
  import MenuOverlay from './MenuOverlay.vue'
  import CloseMenu from "./CloseMenu"
  import MenuButton from './MenuButton.vue'
  import Accordions from '@/components/common/LinkListAccordions.vue'

  export default {
    name: 'MegaMenuMobile',
    props: {
      menus: Array
    },
    data() {
      return {
        open: 0,
      }
    },
    components: {
      MenuOverlay,
      CloseMenu,
      MenuButton,
      Accordions
    },
    mounted(){
      this.hookIntoDepartmentMobileMenu()
    },
    watch: {
      open(menuID){
        // console.log('open: ', menuID)
        const menuIsOpen = menuID > 0,
              open = 'menuIsOpen',
              body =  document.body.classList,
              html =  document.documentElement.classList;

        // Toggle Body Scroll Freeze Classes
        menuIsOpen 
          ? (body.add(open), html.add(open))
          : (body.remove(open), html.remove(open))
      }
    },
    methods: {
      toggleMenu(menu, buttonFocus) {
        // console.log('previously open: ', this.open)
        // console.log({ menu, buttonFocus })

        // Toggle On/Off
        this.open = (this.open === menu) ? 0 : menu

        // Return focus to menu hamburger
        if (this.open == 0) this.setFocus('#mobileMegaMenuToggle')

        // Return focus from level 2 panel to level 1 button
        if (this.open == 1 && buttonFocus > -1) {
          // Wait for panels to finish animating
          setTimeout(() => {
            this.setFocus(`#mmmButton${ buttonFocus }`)
          }, 500)
        }

        // Set Focus to Submenu Close
        if (this.open > 1) {
          // Wait for panels to finish animating
          setTimeout(() => {
            // console.log('focusing on close: ', buttonFocus)
            this.setFocus(`#mmmPanelClose${ buttonFocus }`)
          }, 500)
        }

        // console.log('now open: ', this.open)
      },
      setFocus(selector) {
        document.querySelector(selector).focus()
      },
      hookIntoDepartmentMobileMenu() {
        let joinMegaAndDeptMenus = function() {

            // Create new button to toggle off dept mobile menu & toggle on mega menu
            let deptMegaMenuToggle = document.createElement('button')
                deptMegaMenuToggle.id = 'deptMegaMenuToggle'
                deptMegaMenuToggle.innerHTML = '<span class="fas fa-chevron-left" aria-hidden></span> Main Menu'

            // Find old button to old Main Menu
            let deptBackButton = document.getElementById('backReturn')
            
            // Add new button just before
            if (deptBackButton) {
              deptBackButton.parentNode.insertBefore(deptMegaMenuToggle, deptBackButton)

              // Bind new button
              document.getElementById('deptMegaMenuToggle').addEventListener('click', function() {
                  // Close Department Mobile Menu
                  document.getElementById('mainMenuCloseMobile').click()
                  // Open Mega Menu
                  document.getElementById('mobileMegaMenuToggle').click()
              });

              // Hide back button if back is Main Menu
              let doubleMainMenuFix = function () {
                let backTextElement = deptBackButton.querySelector('#backReturnText')

                // Back text is being set in another file
                // This is temporary until both menus are consolidated
                let backTextObserver = function() {
                  var observer = new MutationObserver(mutations => {
                        mutations.forEach(mutation => {
                          let text = backTextElement.innerText.toLowerCase()

                          if (mutation.type === 'childList') {
                            if (text.includes('main menu')) {
                              // console.log('Double Main Menu Fix: ', text)
                              deptBackButton.classList.add('old-main-menu')
                            } else {
                              // console.log('No Fix Needed: ', text)
                              deptBackButton.classList.remove('old-main-menu')
                            }
                          }
                        }) 
                      })

                  observer.observe(backTextElement, { characterData: false, attributes: false, childList: true, subtree: false })
                }

                if (backTextElement) {
                  try {
                    backTextObserver()
                  } catch (error) {
                    console.log('Unable to see "Back Text"', error)
                  }
                }
              }

              doubleMainMenuFix()
            }
        }



        // Older Slide Out Menus
        // 1) Old Desktop Slide Outs
        // 2) Old Mobile Portal Slide Out
        // 3) Old Mobile Department Out
        let oldMobileMenus = document.getElementById('slideMenuNav')

        let deptMobileMenuExists = document.getElementById('mainMenuCloseMobile') && document.getElementById('seagovMenuMobile')
        let mobileMegaMenuExists = document.getElementById('mobileMegaMenuToggle')

        const isHome = document.querySelector('.home2021') || null,
              isPortalServices = document.querySelector('.PortalServices') || null

        // console.log({isHome, isPortalServices, deptMobileMenuExists, mobileMegaMenuExists})

        if (isHome || isPortalServices) {
          // Hide Department Mobile Menu Toggle          
          let deptToggle = document.getElementById('mainMenuToggle');
          if (deptToggle) deptToggle.remove();
          // Remove Old Mobile Menu from DOM          
          oldMobileMenus.remove()
        } else if (deptMobileMenuExists && mobileMegaMenuExists) {
          // Join Mobile Mega Menu with Department Mobile Menu          
          joinMegaAndDeptMenus()
        }
      }
    },
    computed: {
      isDepartment() {
        return (document.querySelector('#mega-menu, #vue-component-mega-menu')) ? '' : 'isDepartment'
      },
      subMenuOpened() {
        return this.open > 1
      },
      subMenuIndex() {
        return this.open - 2
      },
      subMenu() {
        return (this.subMenuOpened) ? this.menus[this.subMenuIndex] : []
      }
    }
  }
</script>

<style lang="scss">
  #mobileMegaMenuToggle {
    span {
      @media (max-width: 767px) { 
        font-size: 12px;
      }
    }
  }

  body.menuIsOpen {
    overflow: hidden;
    position: relative;
    height: 100vh;
  }

  #mobile-mega-menu {
    &:not(.isDepartment){
      @media (min-width: 1292px) { display: none }
    }

    .panel {
      width: 400px;
      top: 0;
      right: -200%;
      min-height: 100vh;
      max-height: 100vh;
      position: absolute;
      background: #fff;
      z-index: 99999;
      transition: right .75s ease-in-out, visibility 2s ease-out;
      border: 0;
      border-radius: 0;
      overflow-y: auto;
      visibility: hidden;
      display: flex;
      flex-direction: column;

      &.active {
        right: 0;
        visibility: visible;
      }

      @media (max-width: 767px) { 
        width: 100%;
      }

      button {
        outline-color: initial !important; /* OLD #SeaGOV banner has some super strong css  */
      }

      .back-button {
        width: 100%;
        text-align: left;
        display: grid;
        grid-template-columns: 10px 1fr;
        grid-column-gap: 15px;
        align-items: center;
        background: #003da5;
        color: #fff; 
        padding: 15px 20px;
        border: 0px;
      }

      .link-list-accordion button {
        background: #fff !important; /* OLD SeaGOV banner has some super strong css  */
        padding: 15px 20px !important; /* OLD SeaGOV banner has some super strong css  */
      }

      // Some older iOS devices become unclickable towards the bottom of the browser
      &:after {
        content: '';
        display: block;
        height: 100px;
        width: 100%;
      }
    }

    .fade-enter,
    .fade-leave-active {
      opacity: 0;
    }
  }

  /* Fake Department Mega Menu Toggle (Injected into department mobile nav) */
  #deptMegaMenuToggle {
    background: #0047ba;
    color: #fff;
    border: 0px;
    padding: 10px 20px;
    text-align: left;
    width: 100%;

    .fa-chevron-left {
      margin-right: 15px;
    }
  }

  /* 
    Department Pages -- Desktop
    Hide Default Main Menu Button
    Show Mobile Mega Menu 
  */
  @media(max-width:991px) {
    #mainMenuToggle + #mobile-mega-menu #mobileMegaMenuToggle {
      display: none;
    }
  }
  @media(min-width:992px) {
    #mainMenuToggle {
      display: none;
    }
  }

  /* Disable default back button to main menu */
  #backReturn.old-main-menu {
    display:none !important;
  }

  /* Translation Bar Blocking Fix */
  .translated-ltr #seagovMenuMobile {
    top: initial;
  }
</style>